import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://pharmacy.msmatraders.com/backend",
});

export default axiosInstance;
